import Cell from "../gameUtil/Base/Cell";
import FreeSpinCell from "../gameUtil/Free/FreeSpinCell";
import FontConfig from "../config/FontConfig";
import Utils from "../utils/Utils";
import ResourcesDispatcher from "../config/ResourcesDispatcher";
import LinkReelVertical from "../gameUtil/Link/LinkReelVertical";
import LinkReelRotation from "../gameUtil/Link/LinkReelRotation";
import ReelStatic from "../gameUtil/Base/ReelStatic";
import ReelDynamic from "../gameUtil/Base/ReelDynamic";
import FreeSpinReelStatic from "../gameUtil/Free/FreeSpinReelStatic";
import FreeSpinReelDynamic from "../gameUtil/Free/FreeSpinReelDynamic";
window.isButtonSpinning = false;
export default class CreationManager {
    //CREAZIONE RULLI
    static createReels(type, isExpanding) {
        let reels = [];
        const reelsPosition = Utils.generateReelsPosition(ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_REELS, ResourcesDispatcher.GAME_CONSTANTS.REEL_SIZE, ResourcesDispatcher.GAME_CONSTANTS.GRID_BORDER.CENTER);
        let ReelClass;
        if (type === "static") {
            ReelClass = ReelStatic;
        }
        else if (type === "dynamic") {
            ReelClass = ReelDynamic;
        }
        for (let i = 0; i < ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_REELS; i++) {
            const cellCreation = CreationManager.createCells(i);
            let expandingWild = null;
            if (isExpanding) {
                expandingWild = CreationManager.createExpandingWild(cellCreation.cellPositions, 2, i);
            }
            const reel = new ReelClass(reelsPosition[i].x, reelsPosition[i].y, i, cellCreation, expandingWild);
            cellCreation.cells.forEach((cell) => {
                cell.setReel(reel);
                expandingWild ? expandingWild.setReel(reel) : null;
            });
            reels.push(reel);
        }
        return reels;
    }
    //CREAZIONE CELLE
    static createCells(reelIndex) {
        const cells = [];
        const numOfCells = ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_CELLS_PER_REEL + ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_EXTRA_CELLS_PER_REEL;
        const cellsPosition = [];
        for (let i = 0; i < numOfCells; i++) {
            const cell = new Cell(0, 0, i, reelIndex);
            cells.push(cell);
            let cellDisplayListNode = layoutBuilder.getNodeByPath(`Basegame/grid/reels/reel_${reelIndex}/cell_${i}`);
            if (cellDisplayListNode) {
                cellsPosition.push({ x: cellDisplayListNode.coordinates.relative_top_left_to_parent?.x || 0, y: cellDisplayListNode.coordinates.relative_top_left_to_parent?.y || 0 });
            }
            else {
                cellsPosition.push({ x: cell.getContainer().x, y: cell.getContainer().y });
            }
        }
        return { cells: cells, cellPositions: cellsPosition };
    }
    //CREAZIONE RULLI LINK
    static createLinkReels(orientation, type) {
        let linkReels = [];
        let ReelClass;
        if (type === "vertical") {
            ReelClass = LinkReelVertical;
        }
        else if (type === "rotation") {
            ReelClass = LinkReelRotation;
        }
        for (let i = 0; i < ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_LINK_REELS; i++) {
            linkReels[i] = new ReelClass(ResourcesDispatcher.GAME_CONSTANTS.linkReelsPosition[i].x, ResourcesDispatcher.GAME_CONSTANTS.linkReelsPosition[i].y, i, orientation);
            scene.layerManager.gameAreaLayer.linkSymbolsContainer.add(linkReels[i].getContainer());
            scene.layerManager.gameAreaLayer.linkFrameContainer.add(linkReels[i].getFrameContainer());
            scene.layerManager.gameAreaLayer.fixedLinkCellContainer.add(linkReels[i].getAnimationsContainer());
        }
        return linkReels;
    }
    //CREAZIONE RULLI FREESPIN
    static createFreeSpinReels(type) {
        let numOfReels = ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_REELS;
        let reels = [];
        let FreeSpinReelClass;
        if (type === "static") {
            FreeSpinReelClass = FreeSpinReelStatic;
        }
        else if (type === "dynamic") {
            FreeSpinReelClass = FreeSpinReelDynamic;
        }
        const reelsPosition = Utils.generateReelsPosition(numOfReels, ResourcesDispatcher.GAME_CONSTANTS.REEL_SIZE, ResourcesDispatcher.GAME_CONSTANTS.GRID_BORDER.CENTER);
        for (let i = 0; i < numOfReels; i++) {
            const freeSpinCellCreation = CreationManager.createFreeSpinCells(i);
            const reel = new FreeSpinReelClass(reelsPosition[i].x, reelsPosition[i].y, i, freeSpinCellCreation);
            freeSpinCellCreation.cells.forEach((cell) => {
                cell.setFreeSpinReel(reel);
            });
            reels.push(reel);
        }
        return reels;
    }
    //CREAZIONE CELLE FREESPIN
    static createFreeSpinCells(reelIndex) {
        const cells = [];
        const numOfCells = ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_CELLS_PER_REEL + ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_EXTRA_CELLS_PER_REEL;
        const cellsPosition = [];
        for (let i = 0; i < numOfCells; i++) {
            const cell = new FreeSpinCell(0, 0, i, reelIndex);
            cells.push(cell);
            // TODO: change "landscape" with orientation variable
            let cellDisplayListNode = layoutBuilder.getNodeByPath(`FreeSpin/grid/reels/reel_${reelIndex}/cell_${i}`);
            if (cellDisplayListNode) {
                cellsPosition.push({ x: cellDisplayListNode.coordinates.relative_top_left_to_parent?.x, y: cellDisplayListNode.coordinates.relative_top_left_to_parent?.y });
            }
            else {
                cellsPosition.push({ x: cell.getContainer().x, y: cell.getContainer().y });
            }
        }
        return { cells: cells, cellPositions: cellsPosition };
    }
    //CREAZIONE EXPANDING WILD
    static createExpandingWild(cellPosition, index, reelIndex) {
        const expanding = new Cell(cellPosition[index].x, cellPosition[index].y, index, reelIndex);
        expanding.getContainer().setVisible(false);
        expanding.setCellInfo(ResourcesDispatcher.GAME_CONSTANTS.S_EXTRA_WILD);
        return expanding;
    }
    //CREAZIONE FONT
    static createFont(fontFamily) {
        return new FontConfig(fontFamily);
    }
}
